var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3333 8.99996C17.3333 13.6023 13.6023 17.3333 8.99996 17.3333C4.39758 17.3333 0.666626 13.6023 0.666626 8.99996C0.666626 4.39758 4.39758 0.666626 8.99996 0.666626C13.6023 0.666626 17.3333 4.39758 17.3333 8.99996ZM6.47465 6.47467C6.71873 6.23059 7.11445 6.23059 7.35854 6.47467L8.99996 8.11604L10.6413 6.47468C10.8854 6.23061 11.2811 6.23061 11.5252 6.47468C11.7693 6.71876 11.7693 7.11449 11.5252 7.35854L9.88379 8.99996L11.5252 10.6413C11.7693 10.8854 11.7693 11.2811 11.5252 11.5252C11.2811 11.7693 10.8854 11.7693 10.6413 11.5252L8.99996 9.88388L7.35854 11.5252C7.11448 11.7693 6.71874 11.7693 6.47467 11.5252C6.23059 11.2811 6.23059 10.8854 6.47467 10.6414L8.11604 8.99996L6.47465 7.35854C6.23057 7.11448 6.23057 6.71874 6.47465 6.47467Z",
    fill: "#535353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/xIcon.1f8f4e096531a995fed3d53d87618c92.svg";
export { ForwardRef as ReactComponent };